import { GenericListTabView } from "./generic-list-tab";

export class MiscRelationsView extends GenericListTabView {

    public constructor(options?: any) {
        super(options);
    }

}



// WEBPACK FOOTER //
// ./~/tslint-loader??ref--0!./src/desktop/views/tabs/misc-relations.ts